export enum HubSpotNativeObjectType {
	Contacts = 'Contacts',
	Companies = 'Companies',
	Deals = 'Deals',
	Tickets = 'Tickets',
	Calls = 'Calls',
	Emails = 'Emails',
	Meetings = 'Meetings',
	Notes = 'Notes',
	Tasks = 'Tasks',
	Products = 'Products',
	Invoices = 'Invoices',
	LineItems = 'Line_Items',
	// Payments = 14,
	Quotes = 'Quotes',
	Subscriptions = 'Subscriptions',
	Communications = 'Communications',
	// PostalMail = 17,
	// MarketingEvents = 18,
	// FeedbackSubmissions = 19,
	// Appointments = 20,
	// Courses = 21,
	// Listings = 22,
	Services = 'Services',
}
